import React, { useContext, useState, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IGetModifierGroupInfoV2 } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifierGroupInfoV2, updateRestaurantsInModGroup } from 'backend/modifierGroups';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Text from 'components/Text/Text';
import { RestaurantMultipleSelect } from './RestaurantMultipleSelect';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
	modifierGroupId: string;
}

export const ModalAssignModifierGroupToRestaurants: React.FC<IProps> = ({
	onCloseModal,
	onFailureEvent,
	onShowError,
	modifierGroupId,
}) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const [selectedRestaurants, setSelectedRestaurants] = useState<string[]>([]);
	const { response, loading } = useFetchData<IGetModifierGroupInfoV2, string>(
		getModifierGroupInfoV2,
		modifierGroupId,
	);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		if (response) {
			setSelectedRestaurants(response.restaurants.map((restaurant) => restaurant.id));
		}
	}, [response]);

	const handleAssignRestaurants = async () => {
		try {
			showLoader();
			await updateRestaurantsInModGroup({
				modifierGroupId: modifierGroupId,
				restaurantIds: selectedRestaurants,
			});
			onCloseModal();
		} catch (err) {
			onShowError();
		} finally {
			hideLoader();
		}
	};

	return (
		<ModalContent
			onConsentEvent={handleAssignRestaurants}
			onFailureEvent={onFailureEvent ? onFailureEvent : onCloseModal}
			heading="attachedRestaurants"
			headerTranslationNameSpace="listing"
			translationOfConfirmBtn="saveButton"
			headingAlignment="left"
			centered={false}>
			<FullInfoField label="customerLabel" />
			<Text translationKey={response?.customer.name} size="s" />
			<RestaurantMultipleSelect
				setSelectedRestaurants={setSelectedRestaurants}
				selectedRestaurants={selectedRestaurants}
				customerID={response?.customer.id}
			/>
		</ModalContent>
	);
};
